module.exports = __webpack_public_path__ + "img/tg_02 (13).bd76a32e.jpg";